import React, { useEffect, useState } from 'react'
import {  json, useParams } from 'react-router-dom'
import { getImageUrl } from '../../utils/images'
import { useDispatch, useSelector } from 'react-redux'
import { alphanumericWithSpaceOnly, isEmail } from '../../helpers/string'
import {
  createBrandFormActions
} from '../../store/createBrandFormState'
import { UploadDocumentModal } from '../Modals/UploadDocument/UploadDocument.Modal'
import { Brandlogo } from '../ComponentNodes/Brandlogo'
import { getBrandAttachmentsByID, getBrandByID, updateBrandForm } from '../../service/BrandsService'

import { checkIfDomainExists } from '../../helpers/helpers'
import { UpdateBrandlogo } from '../ComponentNodes/UpdateBrandlogo'
import { ViewDocument } from '../Modals/UploadDocument/ViewDocument/ViewDocument.Modal'

export const BrandDetail = () => {
  const [showDocumentViewModal, setShowDocumentViewModal] = useState(false)
 
  const [documentID,setDocumentID]=useState("")

  const [openDocumentDetails, setOpenDocumentDetails] = useState({
    name: '',
    url: '',
    quotation: []
  })

  const dispatch = useDispatch()
  const brandState = useSelector(state => state.brandForm)


  const [attachments, setAttachments] = useState([])
  const [currentDocument, setDocument] = useState({
    file: '',
    isUploading: false,
    isUploaded: false,
    progress: 0,
    url: '',
    name: ''
  })
  const[currentBrandState,setCurrentBrandState]=useState({})



  const [isDocumentModalOpen, setIsDocumentModalOpen] = useState(false)

  const [documentName, setDocumentName] = useState('')




  const openModal = docName => {
    setIsDocumentModalOpen(true)
    setDocumentName(docName)
  }
  const closeModal = () => setIsDocumentModalOpen(false)

  const checkFormFieldsValidation = () => {
    console.log("brandStatenew",brandState)
    const mandatoryFields = document.getElementsByClassName('mandatory')
    let allFieldCaptured = true
    let firstValidationField

    console.log('Starting form validation') // Log to indicate start of validation
    console.log(`Total mandatory fields: ${mandatoryFields.length}`)

    for (let i = 0; mandatoryFields.length > i; i++) {
      const field = mandatoryFields[i]
      console.log(
        `Checking field: ${field.name || field.id || 'Unnamed Field'}`
      )

      // Check if the field is empty or a 'Select' dropdown
      if (field.value == '' || field.value == 'Select') {
        console.log(`Field is empty or "Select": ${field.name || field.id}`)

        const tempSpan = document.createElement('span')
        tempSpan.classList.add('validation-error')
        tempSpan.innerHTML = `${
          field.value == 'Select' ? 'Please select' : 'Please enter'
        } ${field.ariaValueNow || 'this field'}`

        // Check if error message already exists for the field
        if (
          !field?.nextElementSibling?.classList.contains('validation-error')
        ) {
          console.log('Inserting error message')
          field.insertAdjacentElement('afterend', tempSpan)
          field.addEventListener('change', () => {
            console.log(
              `Field changed, removing validation error: ${
                field.name || field.id
              }`
            )
            tempSpan?.remove()
          })
        }

        if (allFieldCaptured) {
          firstValidationField = field
        }
        allFieldCaptured = false
      }

      // Check for email validation
      if (
        field.value !== '' &&
        field.type == 'email' &&
        !isEmail(field.value)
      ) {
        console.log(`Invalid email in field: ${field.name || field.id}`)

        const tempSpan = document.createElement('span')
        tempSpan.classList.add('validation-error')
        tempSpan.innerHTML = `Please enter a valid email`

        // Check if error message already exists for the field
        if (
          !field?.nextElementSibling?.classList.contains('validation-error')
        ) {
          console.log('Inserting email validation error message')
          field.insertAdjacentElement('afterend', tempSpan)
          field.addEventListener('change', () => {
            console.log(
              `Field changed, removing validation error: ${
                field.name || field.id
              }`
            )
            tempSpan?.remove()
          })
        }

        if (allFieldCaptured) {
          firstValidationField = field
        }
        allFieldCaptured = false
      }
    }

    // Final check for form validity
    console.log('Final form validation check')
    if (allFieldCaptured) {
      console.log('All fields are valid, submitting form')

      currentBrandState.attachments=attachments.map((item)=>item.attachments.id)

 console.log("final current",currentBrandState)
        return updateBrandForm(currentBrandState,brandId)
    }

    console.log('Validation failed, focusing on first invalid field')
    firstValidationField?.focus()
  }

  const updateFieldValue = (key, value) => {
    console.log(key, value)
    dispatch(createBrandFormActions.updateValue({ key, value }))
    setCurrentBrandState({...currentBrandState, [key] : value })
    console.log("currentBrandState",currentBrandState)

  }


  console.log('brandState', brandState)


  const { brandId: encodedId } = useParams()

  let brandId = ''

  try {
    brandId = atob(encodedId) ?? encodedId
  } catch (error) {
    brandId = ''
  }
  const fillOutFormState =(formDataRecieved)=>
    {
  
  dispatch(createBrandFormActions.updateAllValues(formDataRecieved))
//   setActiveOffer(formDataRecieved.offerType)
//   setActiveCategory(formDataRecieved.offerCategory)
console.log("formDataRecieved",formDataRecieved)


  setDocument({
    file: "",
    isUploading: false,
    isUploaded: false,
    progress: 0,
    url: formDataRecieved[0].logoURL ? checkIfDomainExists(formDataRecieved[0].logoURL):"",
    name: ""
  });
    }

  const getBrandsData = async () => {
    console.log("brandIDd",brandId)
    // setIsLoading(true)
    const response = await getBrandByID(brandId)
  
    if (response.status === 200) {
      const data = response?.data

      console.log("data",data)
      fillOutFormState(data)
      
      
      // setOfferDetail(data)
      // setIsLoading(false)
      // fillOutFormState(response?.data)
    
    
      // navigator("/applicants")
    }
  }



  const getAllAttachments =async ()=>
  {
     // setIsLoading(true)
     const response = await getBrandAttachmentsByID(brandId)
  
     if (response.status === 200) {
       const data = response?.data
 
       console.log("dataattac",data)
       setAttachments(data?.items)
       
       
       
     
     }
  }


  useEffect(()=>
  {
    getBrandsData()
   
  },[])

  useEffect(()=>
   {
    getAllAttachments()
  },[])


  const removeAttachment = (index) => {
    console.log("called")
    setAttachments((prevAttachments) => prevAttachments.filter((_, idx) => idx !== index));
    console.log("atta",attachments)
  };


  return (
    <div className='page-content'>
        
      <div className='container-fluid'>
        <div className='row'>
          <div className='col-12 col-lg-8'>
            <ul className='breadcrumb'>
              {/* <li className='breadcrumb-item'>
                <a href='#'>Dashboard</a>
              </li> */}

              <li className='breadcrumb-item active' aria-current='page'>
                Brand detail
              </li>
            </ul>
{console.log("mystate",brandState)}
            <div className='row'>
              <div className='col-12 col-lg-6'>
                <h5 className='mb-2 font-weight-700' data-end='*'>
                  Registered brand name
                </h5>
                <div className='form-group mb-4'>
                  <input
                    aria-valuenow={'Registered brand name'}
                    value={brandState.brandName}
                    disabled={true}
                    onChange={e =>{    updateFieldValue(
                        'brandName',
                        alphanumericWithSpaceOnly(e.target.value)
                      );console.log(brandState)}
                  
                    }
                    maxLength={20}
                    type='text'
                    className='form-control mandatory'
                    placeholder='Enter Text Here...'
                  />
                </div>
              </div>
              <div className='col-12 col-lg-6'>
                <h5 className='mb-2 font-weight-700'>
                  Registered email address*
                </h5>
                <div className='form-group mb-4'>
                  <input
                    aria-valuenow={'Email address'}
                    type='email'
                    disabled={true}
                    maxLength={25}
                    value={brandState.emailAddress}
                    className='form-control mandatory'
                    onChange={e =>
                      updateFieldValue('emailAddress', e.target.value)
                    }
                    placeholder='Enter Text Here...'
                  />
                </div>
              </div>
              <div className='col-12 col-lg-6'>
                <h5 className='mb-2 font-weight-700'>Trade license number</h5>
                <div className='form-group mb-4'>
                  <input
                    type='text'
                    aria-valuenow={'Trade license number'}
                    value={brandState.tradeLiceneseNumber}
                    disabled={true}
                    onChange={e =>
                      updateFieldValue(
                        'tradeLiceneseNumber',
                        alphanumericWithSpaceOnly(e.target.value)
                      )
                    }
                    maxLength={30}
                    className='form-control mandatory'
                    placeholder='Enter Here...'
                  />
                </div>
              </div>

              <div className='col-12 col-lg-6'>
                <h5 className='mb-2 font-weight-700'>Address</h5>
                <div className='form-group mb-4'>
                  <textarea
                    className='form-control'
                    rows='5'
                    value={brandState?.address?.city}
                    disabled={true}
                    onChange={e =>
                      updateFieldValue(
                        'address',
                        alphanumericWithSpaceOnly(e.target.value)
                      )
                    }
                    placeholder='Enter Text Here...'
                  ></textarea>
                </div>
              </div>
            </div>
          </div>
          <div className='col-12 col-lg-4'>
            <div className='card card-light mb-3'>
              <div className='card-body'>
                <h5 className='font-weight-700 mb-3'>Publishing details</h5>
                <div className='row'>
                  <div className='col-6'>
                    <div className='form-group'>
                      <label className='text-grey font-8'>
                        Is the brand featured
                      </label>
                      <select
                      value={`${brandState.brandfeatured}`}
                      disabled={true}
                        className='form-control'
                        onChange={e =>
                          updateFieldValue('brandfeatured',  e.target.value === 'true')
                        }
                      >
                       <option value="true">Yes</option>
                       <option value="false">No</option>
                      </select>
                    </div>
                  </div>
                  <div className='col-6'>
                    <div className='form-group'>
                      <label className='text-grey font-8'>
                        Is the brand active
                      </label>
                      <select
                        className='form-control'
                        disabled={true}
                        value={brandState.brandStatus}
                        onChange={e =>
                          updateFieldValue('brandStatus', e.target.value)
                        }
                      >
                        <option value='Select status'>Select status</option>
                        <option value='true'>Active</option>
                        <option value='Draft'>Draft</option>
                        <option value='false'>In Active</option>
                      </select>
                    </div>
                  </div>
                  <div className='col-12'>
                    {/* <button
                      type='button'
                      className='btn btn-default'
                      onClick={() => {
                        checkFormFieldsValidation()
                      }}
                    >
                      Update brand
                    </button>
                    <button type='button' className='btn btn-white ml-2'>
                      Save as draft
                    </button> */}
                  </div>
                </div>
              </div>
            </div>
            <div className='card card-light mb-3'>
              <div className='card-body'>
              <div className='row'>
                      <div className='col-6'>
                        <h5 className='font-weight-700 mb-4'>Uploaded attachments</h5>
                      </div>
                    </div>
                <div className='row'>
                 
{console.log("attachmentsattachments",attachments)}
{console.log("attachmentsattachments",attachments)}
                  {attachments?.length > 0 && (
                    <table className='table mb-0'>
                      <tbody>
                        {attachments?.map((item, key) => {
                          return (
                            <tr key={key}>
                              <td>
                                <div className='align-center'>
                                  <img
                                    className='btn cursor-pointer'
                                    src={getImageUrl('pdf.svg')}
                                    alt='img'
                                  />

                                  <div className='ml-3 font-10'>
                                    {item.hasOwnProperty("attachments") ? <p className='mb-0 font-weight-700'>
                                      {item?.attachments.name.length > 10
                                        ? item?.attachments.name.substring(0, 25) + '...'
                                        : item?.attachments.name}
                                    </p> : <p className='mb-0 font-weight-700'>
                                      {item?.name.length > 10
                                        ? item?.name.substring(0, 25) + '...'
                                        : item?.name}
                                    </p>}
                                   
                                    {/* <p className='mb-0'>added on :  {getDateForInput(item.creationDate)}</p> */}
                                  </div>
                                </div>
                              </td>
                              <td className='text-right'>
                                <div className='d-flex mt-10'>
                                  {' '}
                                  <button
                                    type='button'
                                    onClick={() => {
                                      setShowDocumentViewModal(true)
                                      console.log("itemupdte",item)
                                      setOpenDocumentDetails({
                                        name: item?.attachments?.name,
                                        url: item?.attachments?.link?.href,
                                        documentId:item?.attachments?.id,
                                        quotation: ''
                                      })
                                      // openImageInNewTab(applicationData?.[doc.id]?.link?.href)
                                    }}
                                    className='btn btn-white mx-2'
                                  >
                                    <img
                                      src={getImageUrl('downloadArrow.svg')}
                                      alt='img'
                                      style={{ transform: 'scale(0.7)' }}
                                    />
                                  </button>
                                
                                </div>
                              </td>
                            </tr>
                          )
                        })}
                      </tbody>
                    </table>
                  )}

                  {/* ---------- */}

                  <div className='card-body'>
                   

                  </div>

                  {/* --------- */}
                  <ViewDocument
            show={showDocumentViewModal}
            doc={openDocumentDetails}
            close={setShowDocumentViewModal}
            
          />

                  <UploadDocumentModal
                    show={isDocumentModalOpen}
                    docName={documentName}
                    close={closeModal}
                    attachments={attachments}
                    setAttachments={setAttachments}
                  />
                </div>
              </div>
            </div>
            <UpdateBrandlogo updateFieldValue={updateFieldValue} currentDocument={currentDocument} currentBrandState={currentBrandState} setCurrentBrandState={setCurrentBrandState} setDocument={setDocument}/>
          </div>
        </div>
      </div>
    </div>
  )
}
